<template>
    <div>
        <CModal
            size="xl"
            :centered="true"
            color="white"
            :show.sync="isShownConfirm"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Confirmation</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="closePopUp()" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding: 24px" v-if="dataDetail != null">
                    <CRow v-if="dataDetail.listData.length != 0" class="mb-3">
                        <CCol sm="12">
                            <Tables :data="dataDetail.listData" :th="dataTh" :td="dataTd" :styleTable="styleTable"></Tables>
                        </CCol>
                    </CRow>
                    <CRow class="mt-2 mb-3">
                        <CCol sm="12">
                            <span class="font-weight-bold">Apakah anda yakin ingin menyimpan data shift ?</span>
                        </CCol>
                    </CRow>
                    <CRow style="margin-top: 46px;">
                        <CCol sm="12">
                            <CButton @click="closePopUp()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                            <CButton @click="saveShift()" class="btn btn-edit-submit">
                                <span v-if="loading == false">Ya, Simpan</span>
                                <CSpinner v-else color="default" size="sm"/>
                            </CButton>
                        </CCol>
                    </CRow>
                </div>
                <div style="padding: 24px" v-if="dataDetail == null">
                    <CRow class="mt-2 mb-3">
                        <CCol sm="12">
                            <span class="font-weight-bold">Terjadi Kesalahan.</span>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
</template>

<script>
import Tables from '../../../component/tableShiftNew'
export default {
    components: {
        Tables
    },
    data() {
        return {
            loading: false,
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            isShownConfirm: false,
            dataDetail: null,
            datas: null,

            // Table
            dataTh: [
                'Tanggal',
                'Keterangan',
            ],
            dataTd: [
                'tanggal',
                'keterangan'
            ],
            styleTable: ['200px', '1000px'],
        }
    },
    methods: {
        closePopUp() {
            this.isShownConfirm = false
            this.loading = false
            this.dataDetail = null
            this.datas = null
        },
        saveShift() {
            this.$emit('submit', this.datas)
        },
    },
    watch: {
    },
    mounted() {
    },
}
</script>
<style scoped>
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
</style>